import { UploadFile } from 'ng-zorro-antd';

export class UploadModel {
    hospCode?: string;
    sectionCode?: string;
    orderNo?: string;
    fileType?: string;
    file?: FileModel[];
}

export class FileModel {
    fileName?: string;
    fileData?: string;
}

export class FileModelUser {
    fileName?: string;
    file?: string;
    fileSize?: number;
    fileData?: UploadFile;
}
